import { Component, OnInit, ViewChild } from '@angular/core';//AfterViewInit,
import { Router } from '@angular/router'; //, NavigationExtras
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { FormBuilder, Validators} from '@angular/forms'; //FormGroup, FormControl,
import { HttpEvent, HttpEventType } from '@angular/common/http';

// PROVIDER
import {BasicProvider} from '../providers/basic/basic';
import {UserProvider} from '../providers/user/user';
//import { CommonService } from '../providers/common.service';
import { AccountHeaderComponent }  from '../account-header/account-header.component';

@Component({
  selector: 'app-authorized-collect',
  templateUrl: './authorized-collect.component.html',
  styleUrls: ['./authorized-collect.component.css']
})
export class AuthorizedCollectComponent implements OnInit {

  search_key ='';
  next_date = '';
  next_id = '';
  pickedList:any;
  warehouselist:any;
  hDataMore = true;
  pDataMore = true;
  hNoRecordFound = false;
  pNoRecordFound = false;
  package_status_ary:any;
  showPopup : boolean = false;
  popClass = '';
  inProcess = false;
  hLastId = '';
  hNoData = false;
  pLastId = '';
  pNoData = false;
  showFilter = false;
  selector = '';
  authorizedUsers = [];
  showAddNewPersonForm = false;
  file;
  uploadInProgress = false;
  uploadProgress = 0;
  hasValue = false;
  fileUploadType;

  constructor(
    public bp: BasicProvider,
    public up: UserProvider,
    public router: Router,
    public httpClient: HttpClient,
    public builder:FormBuilder,
    //private CommonService: CommonService
  ) {  }

  authorizedCollectForm = this.builder.group({
    name: ['', Validators.compose([this.bp.required])],
    phone_number: ['', Validators.compose([this.bp.required, Validators.pattern(/^[0-9]+/), Validators.minLength(8), Validators.maxLength(10)])],
    id_number: ['', Validators.compose([this.bp.required])],
    profile: ['', Validators.compose([this.bp.required])],
    id_proof: ['', Validators.compose([this.bp.required])],
    profileName: [''],
    idProofName: [''],

  });
  authorizedCollectFormError;
  validation_message = {
    'profile': {
      'required': 'Profile image is required'
    },
    'id_proof': {
      'required': 'Id propf is required.'
    },
    'name': {
      'required': 'Name is required.'
    },
    'id_number': {
      'required': 'Id number is required.'
    },
    'phone_number': {
      'required': 'Phone number is required.',
      'pattern': 'Please enter valid phone.',
      'minlength': 'phone number length must be between 8 to 10.',
      'maxlength': 'phone number length must be between 8 to 10.'
    }
  };
  ngOnInit() {
    this.getAuthorizedCollectors();
  }


  getAuthorizedCollectors(){
    // users/authorized_users
    let api = "users/authorized_users";
    this.bp.hitApi(api, 'GET', {},true,true)
    .subscribe(
      (success) => {
        if( success.type == true ){
          this.authorizedUsers = success.data;
        }
      })
  }

  addNewPerson(){
    this.showAddNewPersonForm = !this.showAddNewPersonForm;
    if(this.showAddNewPersonForm)
      window.scrollTo({ top: 0,  behavior: 'smooth' });
    this.authorizedCollectForm.reset();
    this.authorizedCollectFormError = '';
  }

  submit(){
    if (this.bp.validation(this.authorizedCollectForm, this.validation_message)) {
      let api = `users/add_authorized_person`;
      this.bp.hitApi(api, 'POST', this.authorizedCollectForm.value, true, true)
      .subscribe(
        (success) => {
          if (success.type == true) {
            this.addNewPerson();
            this.bp.show_toast('Success',success.message);
            this.getAuthorizedCollectors();
          } else {
            this.bp.show_toast('Error',success.message);
          }
        })
      console.log("form data----->", this.authorizedCollectForm.value);
    } else {
      this.authorizedCollectFormError = this.bp.validation_error;
    }
  }

  removeUser(id){
    // users/delete_authorized_person?id='+data.id
    if(confirm("Do you want to delete this collector?")) {
      let api = `users/delete_authorized_person`;
      this.bp.hitApi(api, 'DELETE', {id}, true, true)
      .subscribe(
        (success) => {
          if (success.type == true) {
            this.bp.show_toast('Success',success.message);
            this.getAuthorizedCollectors();
          } else {
            this.bp.show_toast('Error',success.message);
          }
        })
    }
  }

  onchangeFile(event, fileType){
    this.fileUploadType = fileType;
    let allowFileType=['jpg', 'png', 'jpeg'];
    let selectedFileType =  event.target.files.length ? event.target.files[0].name.split('.').pop().toLowerCase() : '';
    if(!selectedFileType)
      return;

    if(!allowFileType.includes(selectedFileType)){
      this.bp.show_toast('Error', 'Please select correct file of allow format. Allowled format are jpg, png, jpeg');
      return;
    }

    let data = {location: 'users', type: 'IMAGE'};
    let api = `warehouse/upload_files`;
    const [file] = event.target.files;
    this.file = file;

      this.bp.hitApi(api, 'GET', data, true, true)
      .subscribe(
        (success) => {
          console.log("data=====-->", success);
          if (success.type == true) {

            this.bp.upload(success.data[0].url, file, null, true)
            //.pipe(finalize(() => this.isBusy = false))
            .subscribe(
              (event: HttpEvent<any>) => {
                  switch (event.type) {
                    case HttpEventType.Sent:
                      this.uploadInProgress = true;
                      break;
                    case HttpEventType.UploadProgress:
                      this.uploadProgress = Math.round(100 * event.loaded / event.total);
                      break;
                    case HttpEventType.Response:
                      this.resetUploadProgress();
                      this.file = undefined;
                      this.hasValue = true;
                      if(fileType == 'profile'){
                        this.authorizedCollectForm.patchValue({
                          profile: success.data[0].location,
                          profileName: success.data[0].location.split('/').pop()
                        })
                      } else {
                          this.authorizedCollectForm.patchValue({
                            id_proof: success.data[0].location,
                            idProofName: success.data[0].location.split('/').pop()

                          })
                      }
                  }
              })

          } else {
            this.bp.show_toast('Error',success.message);
          }
        })
  }


  private resetUploadProgress() {
    this.uploadInProgress = false;
    this.uploadProgress = 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/authorized-collect/authorized-collect.component.ts